<template>
  <div class="empty-list-state">
    <img
      :src="displayInfo.img"
      :srcset="`${displayInfo.img} 1x, ${displayInfo.img2x} 2x, ${displayInfo.img3x} 3x`"
      :alt="displayInfo.title"
    >
    <h3>{{displayInfo.title}}</h3>
    <p>{{ displayInfo.description }}</p>
    <div class="empty-list-state__action">
      <template v-if="isMultiEntity">
        <new-task-button v-if="isProject" />
      </template>
      <template v-else>
        <new-conversation-button v-if="isMailbox" :mailbox-id="parseInt($route.params.id, 10)" />
        <new-task-button v-if="isProject && !isDisabled" :project-id="parseInt($route.params.id, 10)" />
      </template>
    </div>
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */
import mailboxesImg from '@/assets/img/entities/illustration-mailbox-empty-state.png'
import mailboxesImg2x from '@/assets/img/entities/illustration-mailbox-empty-state@2x.png'
import mailboxesImg3x from '@/assets/img/entities/illustration-mailbox-empty-state@3x.png'
import projectsImg from '@/assets/img/entities/illustration-project-empty-state.png'
import projectsImg2x from '@/assets/img/entities/illustration-project-empty-state@2x.png'
import projectsImg3x from '@/assets/img/entities/illustration-project-empty-state@3x.png'

/* Helpers */

/* Data types */
import { EEntities } from '@/types'

/* API */

export default defineComponent({
  name: 'EmptyListState',

  props: {
    type: {
      type: String as () => EEntities,
      required: true,
    },

    isMultiEntity: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      displayInfos: {
        mailboxes: {
          title: 'No conversations here!',
          description: `Please try a different filter.`,
          img: mailboxesImg,
          img2x: mailboxesImg2x,
          img3x: mailboxesImg3x,
        },
        projects: {
          title: 'No tasks here!',
          description: `Please try a different filter.`,
          img: projectsImg,
          img2x: projectsImg2x,
          img3x: projectsImg3x,
        },
      },
    }
  },

  computed: {
    displayInfo(): any {
      return this.displayInfos[this.type]
    },
    isMailbox(): boolean {
      return this.type === EEntities.MAILBOXES
    },
    isProject(): boolean {
      return this.type === EEntities.PROJECTS
    },
  },
})
</script>

<style lang="scss">
.empty-list-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  padding: 40px 10px 0 10px;

  img {
    margin-bottom: 10px;
  }

  @include media-breakpoint-down(sm) {
    padding-top: 10px;

    img {
      width: 220px;
    }
  }

  &__action {
    margin-top: 12px;
  }
}
</style>
